// Thin wrapper around Plausible + Google Analytics 4 (both loaded in __root.tsx).
// Safe in SSR - no-ops on the server and when neither is ready.
declare global {
  interface Window {
    plausible?: (
      event: string,
      opts?: { props?: Record<string, string | number | boolean>; callback?: () => void },
    ) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

const INTERNAL_RX = /^\/(admin|founder|health|me|saved|history|_authenticated)(\/|$)/;
function isInternalTraffic(): boolean {
  if (typeof window === "undefined") return true;
  try { if (window.localStorage.getItem("sa.internal") === "1") return true; } catch { /* ignore */ }
  try { if (INTERNAL_RX.test(window.location.pathname)) return true; } catch { /* ignore */ }
  return false;
}

export function track(event: string, props?: Record<string, string | number | boolean>) {
  if (typeof window === "undefined") return;
  if (isInternalTraffic()) return;
  try {
    window.plausible?.(event, props ? { props } : undefined);
  } catch {
    /* never break the UI for analytics */
  }
  try {
    // Mirror to GA4 so the same events show up in Realtime + Events.
    const gaName = event.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 40) || "custom_event";
    window.gtag?.("event", gaName, props ?? {});
  } catch {
    /* ignore */
  }
}

// Fire an event at most once per session per key.
export function trackOnce(key: string, event: string, props?: Record<string, string | number | boolean>) {
  if (typeof window === "undefined") return;
  try {
    const k = `sa.ev.${key}`;
    if (window.sessionStorage.getItem(k)) return;
    window.sessionStorage.setItem(k, "1");
    track(event, props);
  } catch {
    track(event, props);
  }
}
